import React, { FunctionComponent } from 'react';

import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';
import slugify from 'slugify';

const getTypographyVariant = (style = 'normal') => {
  switch (style) {
    case 'h1':
      return 'headline1';
    case 'h2':
      return 'headline2';
    case 'h3':
      return 'headline3';
    case 'h4':
      return 'headline4';
    default:
      return 'paragraph';
  }
};

const getElement = (style = 'normal') => {
  switch (style) {
    case 'h1':
    case 'h2':
    case 'h3':
    case 'h4':
    case 'h5':
      return style;
    default:
      return 'p';
  }
};

const useStyles = () => {
  const { spacing } = useTheme();
  return {
    root: {
      display: 'inline-flex',
      /**
       * The following seemingly crazy values are needed in order to bypass fixed header when jumping to an id
       * https://stackoverflow.com/a/13881860
       *
       * Update: we will also disallow pointer events in those sections in order to not block contents that we are on top of.
       */
      margin: spacing(-8, 0, 2),
      padding: spacing(14, 0, 0),
      pointerEvents: 'none',
    },
  } as const;
};

const Block: FunctionComponent<any> = (props) => {
  const { style, children = [] } = props.node;

  const variant = getTypographyVariant(style);
  const element = getElement(style);
  const classes = useStyles();

  if (style === 'h2' && children.length === 1 && children[0]?.text) {
    const id = slugify(children[0].text);

    return (
      <Text id={id} css={classes.root} as="h2" gutter={2} variant={variant}>
        {props.children}
      </Text>
    );
  }
  return (
    <Text gutter={2} as={element} variant={variant} css={{ whiteSpace: 'pre-wrap' }}>
      {props.children}
    </Text>
  );
};

const blockRenderer = (props: any) => <Block {...props} />;

export default blockRenderer;
